export const ignoredErrors: string[] = [
	'token.invalid',
	'standard.delete.forbidden',
];
